import React from 'react';

import { FormContainer } from '@eika-kortbetjening/form-container';

import fallbackDictionary from './fallbackDictionary';
import Footer from './footer/Footer';
import Form from './form/Form';
import { PinChangeOption, Piwik, SiteCoreDictionary } from './types';

interface PinChangeDecisionFormProps {
    /** Selected option */
    selectedOption: PinChangeOption | undefined;
    /** Function to set selected option */
    setSelectedOption: (option: PinChangeOption | undefined) => void;
    /** Error in form */
    pinChangeDecisionError?: string | undefined;
    /** Function for the next button */
    next: () => void;
    /** Function for the cancel button */
    cancel: () => void;
    /** Sitecore dictionary */
    sitecoreDictionary?: SiteCoreDictionary;
    /** Set the component to be a part of order new debit card form */
    isOrderingNewDebitCard?: boolean;
    /** PIWIK tags */
    piwik?: Piwik;
}

const PinChangeDecisionForm = ({
    selectedOption,
    setSelectedOption,
    pinChangeDecisionError,
    next,
    cancel,
    sitecoreDictionary,
    piwik,
    isOrderingNewDebitCard,
}: PinChangeDecisionFormProps): React.JSX.Element => {
    const dictionary = { ...fallbackDictionary, ...sitecoreDictionary };

    return (
        <FormContainer>
            <FormContainer.Content>
                <Form
                    selectedOption={selectedOption}
                    setSelectedOption={setSelectedOption}
                    dictionary={dictionary}
                    pinChangeDecisionError={pinChangeDecisionError}
                    isOrderingNewDebitCard={isOrderingNewDebitCard}
                />
            </FormContainer.Content>
            <FormContainer.Footer>
                <Footer next={next} cancel={cancel} dictionary={dictionary} piwik={piwik} />
            </FormContainer.Footer>
        </FormContainer>
    );
};

export default PinChangeDecisionForm;
